import { FC, Fragment } from "react";
import { RiskColumn } from "./riskColumns";
import { LinkIndex, epiOptionCa, linkOptionLabel } from "./riskEditorState";

interface Props {
	index: LinkIndex;
	column: RiskColumn;
	option: string;
}

const RiskLinkOption: FC<Props> = ({ index, column, option }) => {
	if (column.link !== 'EPI') {
		return <Fragment>{linkOptionLabel(index, column, option)}</Fragment>;
	}
	const { epi, ca, missing } = epiOptionCa(index, option);
	return (
		<Fragment>
			{epi}
			{!!ca && <span className="ca-opcao">CA {ca}</span>}
			{missing && <span className="ca-opcao ausente">CA não encontrado</span>}
		</Fragment>
	);
};

export default RiskLinkOption;